/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React from "react";
import { AuditListingItem } from "./audit-listing-item";
import { AuditTableV2 } from "./audit-table-v2";

export const AuditListing = ({ data, parentKey }: any) => {
  const arrayEntries = Object.entries(data).filter(([_, value]) =>
    Array.isArray(value)
  );
  return (
    <React.Fragment>
      {arrayEntries.length === 0 ? (
        arrayEntries.map(([key, value], index: number) => (
          <AuditListingItem
            parentKey={`${parentKey}.${key}`}
            data={value}
            key={key}
            keyValue={key}
            isFirstRow={index === 0}
          />
        ))
      ) : (
        <AuditTableV2 data={data} parentKey={parentKey} />
      )}
    </React.Fragment>
  );
  // return (
  //   <React.Fragment>
  //     <pre>
  //       <code>{JSON.stringify(data, null, 2)}</code>
  //     </pre>
  //     {Object.entries(data).map(([key, value], index: number) => {
  //       return (
  //         <AuditListingItem
  //           parentKey={`${parentKey}.${key}`}
  //           data={value}
  //           key={key}
  //           keyValue={key}
  //           isFirstRow={index === 0}
  //         />
  //       );
  //     })}
  //   </React.Fragment>
  // );
};
